// AUTO-GENERATED by scripts/generate-version.js — do not edit or commit.
export const version = '0.0.1';
export const commitSha = '632cfa6';
export const buildDate = '2026-08-21T04:12:21.369Z';
